// From https://stackoverflow.com/questions/16308037/detect-when-elements-within-a-scrollable-div-are-out-of-view
const isInView = (container: HTMLDivElement, element: HTMLElement, partial: boolean) => {
  // Get container properties
  const cTop = container.scrollTop;
  const cBottom = cTop + container.clientHeight;

  // Get element properties
  const eTop = element.offsetTop;
  const eBottom = eTop + element.clientHeight;

  // Check if in view
  const isTotal = eTop >= cTop && eBottom <= cBottom;
  const isPartial =
    partial && ((eTop < cTop && eBottom > cTop) || (eBottom > cBottom && eTop < cBottom));

  // Return outcome
  return isTotal || isPartial;
};

export { isInView };
